import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import handleRequestError from '../../utils/handleRequestError';

const initialState = {
  isLoading: true,
  data: [],
  filters: {
    startdate: null,
    enddate: null,
    userid: '',
    companyid: '',
    locationid: '',
    productid: '',
  },
  error: '',
};

export const fetchHarvestReport = createAsyncThunk(
  'harvestReport/fetchHarvestReport',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_HOST_API_KEY}/harvests/harvest-report`, {
        params: { ...params },
      });

      return response.data;
    } catch (err) {
      return handleRequestError(err, rejectWithValue);
    }
  }
);

const harvestReportSlice = createSlice({
  name: 'harvestReportSlice',
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters(state) {
      state.filters = {
        ...state.filters,
        userid: '',
        companyid: '',
        locationid: '',
        productid: '',
      };
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchHarvestReport.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchHarvestReport.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.error = '';
      state.data = payload.data;
    });
    builder.addCase(fetchHarvestReport.rejected, (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    });
  },
});

export const { setData, setFilters, resetFilters } = harvestReportSlice.actions;

export default harvestReportSlice.reducer;

export const selectHarvestReportFilters = (state) => state.harvestReport.filters;
export const selectHarvestReportData = (state) => state.harvestReport.data;
export const selectHarvestReportLoading = (state) => state.harvestReport.isLoading;
export const selectHarvestReportError = (state) => state.harvestReport.error;
